import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { CONTACT, SERVICES } from "@/lib/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="logo" className="h-14 w-14 object-contain bg-white rounded-sm p-1" />
            <span className="font-display font-extrabold leading-tight">KELOWNA<br/><span className="text-[#94A3B8] text-xs tracking-widest">CARPET CLEANING</span></span>
          </div>
          <p className="text-sm text-[#94A3B8] leading-relaxed">
            Deep Clean. Fast Dry. Honest Service. Proudly serving the Okanagan with premium carpet & upholstery care.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4 text-sm tracking-widest uppercase text-[#94A3B8]">Services</h4>
          <ul className="space-y-2 text-sm text-white/80">
            {SERVICES.map((s) => (
              <li key={s.id}><a href="#services" className="hover:text-[#2B4BB8]">{s.name}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4 text-sm tracking-widest uppercase text-[#94A3B8]">Contact</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-3"><Phone className="w-4 h-4 text-[#2B4BB8] shrink-0" /><a href={CONTACT.phoneHref}>{CONTACT.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-[#2B4BB8] shrink-0" /><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-[#2B4BB8] shrink-0" />{CONTACT.area}</li>
            <li className="flex gap-3"><Clock className="w-4 h-4 text-[#2B4BB8] shrink-0" />{CONTACT.hours}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold mb-4 text-sm tracking-widest uppercase text-[#94A3B8]">Get Started</h4>
          <a href="#book" className="inline-flex bg-[#2B4BB8] text-white font-bold px-6 py-3 rounded-sm hover:bg-white hover:text-[#1A2A5E] transition-colors">
            Book Your Cleaning
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#94A3B8]">
          <span>© {new Date().getFullYear()} Kelowna Carpet Cleaning. All rights reserved.</span>
          <a href="/admin/login" data-testid="admin-footer-link" className="hover:text-white">Staff Login</a>
        </div>
      </div>
    </footer>
  );
}
